<template>
    <div>
      <a-card class="m-height-full m-display-flex flex-column">
        <div slot="title">
          <span>{{ this.id ? 'Edit' : 'Create' }} Budget</span>
        </div>
        <template slot="extra">
        </template>
        <a-spin
          :spinning="loading.page"
          tip="Preparing To Show Data ...  "
        >
          <div class="container-essential">
              <a-row :gutter="24">
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <a-form :form="form">
                    <a-form-item label="Budget Type">
                      <a-select
                        showSearch
                        :disabled="isRevise"
                        v-decorator="['budget_type', { rules: [{ required: true }], initialValue: isRevise ? reviseData.budget_type : null }]"
                        @change="setBudget"
                      >
                        <a-select-option v-for="item in budget_list" :key="item.jns_anggaran_id">
                          {{ item.jns_anggaran_id }} - {{ item.nm_anggaran }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item label="Budget Year">
                      <a-select
                        showSearch
                        :disabled="isRevise"
                        v-decorator="['periode', { rules: [{ required: true }], initialValue: isRevise ? reviseData.year : null }]"
                        @change="setPeriode"
                      >
                        <a-select-option v-for="item in year_list" :key="item">
                          {{ item }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item label="Project Code">
                      <a-select
                        showSearch
                        :disabled="isRevise"
                        v-decorator="['rc_code', { rules: [{ required: true }], initialValue: isRevise ? reviseData.project : null }]"
                        :loading="loading_rc"
                        @change="onChangeRc"
                      >
                        <a-select-option v-for="item in rc_code_list" :key="item.project_id" :value="item.project_id">
                          {{ item.cost_center_kode }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>

                    <a-form-item label="Upload Template Excel">
                      <a-upload
                        :fileList="fileList"
                        v-decorator="[
                          'file_upload',
                          { rules: [{ required: true,validator: doc_validation }]},
                        ]"
                        :remove="handleRemove"
                        :beforeUpload="beforeUpload"
                      >
                        <a-button :disabled="lock_header">
                          <a-icon type="upload" />Select File
                        </a-button>
                      </a-upload>
                    </a-form-item>
                    <div>
                      <small v-if="linkDocument !== ''">**If you dont have a file upload template, please click 
                        <a-button type="link" class="padding-remove" @click="handleDownload">
                          <small>Download Template</small>
                        </a-button>
                      </small>
                    </div>
                    
                    <div>
                      <a-button type="primary" class="margin-top" @click="handlePreview" :loading="loading.preview" :disabled="lock_header || isDisablePreview">
                        Preview
                      </a-button>
                      <a-button v-if="lock_header" type="danger" class="margin-left" @click="handleReset" :loading="loading.reset">
                        Reset
                      </a-button>
                    </div>
                  </a-form>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
                  <a-spin
                  :spinning="loading.show_data"
                  tip="Preparing To Show Data ...  "
                  >
                    <a-row :gutter="16" type="flex" class="side-preview">
                      <a-col :gutter="16" :xs="{ span: 12 }" :lg="{ span: 8 }">
                        
                        <div class="list-item">
                          <label for="" class="title">BUDGET TYPE</label>
                          <span>{{ stateRc.budget_type ? stateRc.budget_type : '-' }}</span>
                        </div>

                        <div class="list-item">
                          <label for="" class="title">COST CENTER CODE</label>
                          <span>{{ stateRc.cost_center_kode ? stateRc.cost_center_kode : '-' }}</span>
                        </div>

                        <div class="list-item">
                          <label for="" class="title">JOB NAME</label>
                          <span>{{ stateRc.job_name ? stateRc.job_name : '-' }}</span>
                        </div>

                        <div class="list-item">
                          <label for="" class="title">FISCAL YEAR</label>
                          <span>{{ stateRc.fiscal_year ? stateRc.fiscal_year : '-' }}</span>
                        </div>

                        <div class="list-item">
                          <label for="" class="title">COMPILER</label>
                          <span>{{ stateRc.compiler ? stateRc.compiler : '-' }}</span>
                        </div>

                        <div class="list-item">
                          <label for="" class="title">SITE</label>
                          <span>{{ stateRc.site ? stateRc.site : '-' }}</span>
                        </div>

                      </a-col>

                      <a-col :gutter="16" :xs="{ span: 12 }" :lg="{ span: 8 }">
                        
                        <div class="list-item">
                          <label for="" class="title">BUDGET GA AUTHORITY</label>
                          <span>{{ stateRc.budget_ga_authority ? stateRc.budget_ga_authority : '-' }}</span>
                        </div>

                        <div class="list-item">
                          <label for="" class="title">BUDGET MARKETING/IBD</label>
                          <span>{{ stateRc.budget_marketing_ibd ? stateRc.budget_marketing_ibd : '-' }}</span>
                        </div>

                        <div class="list-item">
                          <label for="" class="title">BUDGET OPERATION AUTHORITY</label>
                          <span>{{ stateRc.budget_operation_authority ? stateRc.budget_operation_authority : '-' }}</span>
                        </div>

                        <!-- <div class="list-item">
                          <label for="" class="title">BUDGET GENERAL AFFAIR</label>
                          <span>{{ stateRc.budget_ga_authority ? stateRc.budget_ga_authority : '-' }}</span>
                        </div>

                        <div class="list-item">
                          <label for="" class="title">BUDGET FINANCE</label>
                          <span>{{ stateRc.budget_finance_authority ? stateRc.budget_finance_authority : '-' }}</span>
                        </div> -->

                        <div class="list-item">
                          <label for="" class="title">BUDGET DIRECTORATE</label>
                          <span v-if="stateRc.project_direktorat">{{ stateRc.project_direktorat+" - "+stateRc.pic_direktorat}}</span>
                          <b v-else style="color:red">-- NOT SET YET --</b>
                        </div>

                        <div class="list-item" v-if="stateRc && stateRc.budget_type && stateRc.budget_type.includes('(02)')">
                          <label for="" class="title">DEPARTMENT</label>
                          <span v-if="stateRc.project_departmen">{{ stateRc.project_departmen+" - "+stateRc.project_departmen}}</span>
                          <b v-else style="color:red">-- NOT SET YET --</b>
                        </div>

                        <div class="list-item" v-if="stateRc && stateRc.budget_type && stateRc.budget_type.includes('(02)')">
                          <label for="" class="title">HEAD OF DEPARTMENT</label>
                          <span v-if="stateRc.pic_direktorat">{{ stateRc.pic_direktorat}}</span>
                          <b v-else style="color:red">-- NOT SET YET --</b>
                        </div>

                      </a-col>

                      <a-col :gutter="16" :xs="{ span: 12 }" :lg="{ span: 8 }">
                        
                        <div class="list-item">
                          <label for="" class="title">SALES NOTIF NUMBER</label>
                          <span>{{ stateRc.notif_number ? stateRc.notif_number : '-' }}</span>
                        </div>

                        <div class="list-item">
                          <label for="" class="title">PLAFON TYPE</label>
                          <span>{{ stateRc.plafon ? stateRc.plafon : '-' }}</span>
                        </div>

                      </a-col>
                    </a-row>
                  </a-spin>
                </a-col>

              </a-row>
              <a-divider class="margin-small"/>
              <a-row :gutter="16" type="flex" justify="end">
                <!-- <a-col>
                  <a-button type="primary" class="margin-top" @click="handlePreview" :loading="loading.preview" :disabled="lock_header">
                    Preview
                  </a-button>
                  <a-button v-if="lock_header" type="danger" class="margin-left" @click="handleReset" :loading="loading.reset">
                    Reset
                  </a-button>
                </a-col> -->
              </a-row>
          </div>
          <a-table
            class="ccd margin-top"
            :columns="columns"
            :rowKey="(record, index) => {return index;}"
            :dataSource="dataSource.data"
            :pagination="false"
            size="small"
            :scroll="{ x: 'max-content', y: 500 }"
            bordered
          >
            <template slot="title">
              <a-row :gutter="16" type="flex" justify="space-between" align="middle">
                <a-col>
                  <div class="ant-card-head-title" ><b>Budget Detail</b></div>
                </a-col>
                <a-col>
                  <a-input-search
                    v-model="search"
                    placeholder="Search Budget Detail .. "
                  />  
                </a-col>
              </a-row>
            </template>

            <template slot="no" slot-scope="text, data, index">
              {{ index + 1 }}
            </template>

            <template slot="budget" slot-scope="item, data, index">
              <span style="display: block; text-align: left;" :class="itemChild(data)">{{ item }}</span>
            </template>

            <template slot="kode_anggaran" slot-scope="item">
              <span>{{ item }}</span>
            </template>

            <template slot="unit_price" slot-scope="item, data, index">
              <CurrencyJustified
                v-if="data.type == 'item'"
                currencyValue="IDR"
                :valueNumber="item"
              />
            </template>

            <template v-for="bln in bulan" :slot="bln.bulan" slot-scope="item, data, index">
              <CurrencyJustified
              v-if="data.type == 'item'"
                currencyValue="IDR"
                :valueNumber="item"
              />
            </template>

            <template slot="sub_total" slot-scope="item, data, index">
              <CurrencyJustified
                v-if="data.type == 'item'"
                currencyValue="IDR"
                :valueNumber="item"
              />
            </template>

            <template slot="deskripsi" slot-scope="item">
              {{ item.keterangan }}
            </template>

            <template slot="footer">
              <a-row :gutter="16" type="flex" justify="space-between" align="top">
                <!-- <a-col style="text-align: right;">
                  <a-statistic title="Total Deduction Value (IDR)" :value="total_deduction" />
                  <a-button type="primary" icon="save" class="margin-top" @click="handleSubmit" :loading="loading.submit" :disabled="!lock_header">Submit</a-button>
                </a-col> -->
              </a-row>
            </template>
          </a-table>

          <a-card v-if="dataSource.subtotal_row" class="margin-top">
            <a-row v-for="n of dataSource.subtotal_row" :key="n">
              <a-col v-if="!getScreen" :xs="{ span: 24 }" :lg="{ span: 8 }">
                <div><b>
                  {{ dataSource.subtotal_data[ n>1 ? (n*3)-3 : n-1] ? (dataSource.subtotal_data[ n>1 ? (n*3)-3 : n-1].label) :"" }}
                </b></div>
                <div>
                  {{ dataSource.subtotal_data[ n>1 ? (n*3)-3 : n-1] ? 
                    (formatRupiah(dataSource.subtotal_data[ n>1 ? (n*3)-3 : n-1].value)) :
                    "" }}
                </div>
              </a-col>
              <a-col v-if="!getScreen" :xs="{ span: 24 }" :lg="{ span: 8 }">
                <div><b>
                  {{ dataSource.subtotal_data[ n>1 ? (n*3)-2 : n] ? dataSource.subtotal_data[ n>1 ? (n*3)-2 : n].label : '' }}
                </b></div>
                <div>
                  {{ dataSource.subtotal_data[ n>1 ? (n*3)-2 : n] ?
                  (formatRupiah(dataSource.subtotal_data[ n>1 ? (n*3)-2 : n].value)):
                  "" }}
                </div>
              </a-col>
              <a-col v-if="!getScreen" :xs="{ span: 24 }" :lg="{ span: 8 }">
                <div><b>
                  {{ dataSource.subtotal_data[ n>1 ? (n*3)-1 : n+1] ? (dataSource.subtotal_data[ n>1 ? (n*3)-1 : n+1].label) : '' }}
                </b></div>
                <div>
                  {{ dataSource.subtotal_data[ n>1 ? (n*3)-1 : n+1] ? (formatRupiah(dataSource.subtotal_data[ n>1 ? (n*3)-1 : n+1].value)): '' }}
                </div>
              </a-col>
              <a-col v-if="getScreen" :xs="{ span: 24 }" :lg="{ span: 24 }">
                <div><b>
                  {{ dataSource.subtotal_data[n].label }}
                </b></div>
                <div>
                  {{ formatRupiah(dataSource.subtotal_data[n].value) }}
                </div>
              </a-col>
            </a-row>
          </a-card>
          
          <a-card class="m-height-full m-display-flex flex-column margin-top-10">
            <div slot="title">
              <span><b>Action</b></span>
            </div>
            <div class="container-essential">
              <a-row :gutter="16">
                <a-col :gutter="16" :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <div class="action-card">
                    <div class="m-display-flex flex-row">
                      <span class="margin-remove"><b>Approval Budget</b></span>
                      </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item v-for="(timeline, index) in timeline" :key="index"
                        class="m-display-flex flex-row nowrap" color="green">
                        <div v-if="Array.isArray(timeline)" style="display: flex; width: 100%;">
                          <a-form :form="form" style="width: 100%;">
                            <a-form-item>
                              <a-select
                                style="width: 100%;"
                                showSearch
                                :placeholder="timeline[0].actor"
                                v-decorator="[timeline[0].step_no, { rules: [{ required: true, message: timeline[0].actor + ' is required' }] }]"
                              >
                                <a-select-option v-for="item in timeline" :key="item.tlc" :value="item.tlc">
                                  {{ item.actor }} - {{ item.nama }}
                                </a-select-option>
                              </a-select>
                            </a-form-item>
                          </a-form>
                        </div>
                        <span v-else class="margin-right">{{ timeline.actor }} - {{ timeline.nama }}</span> 
                        <!-- <status :class="getScreen ? 'margin-remove' : ''" :status="timeline.tlc" /> -->
                      </a-timeline-item>
                    </a-timeline>
                  </div>
                </a-col>

                <a-col :gutter="16" :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form :form="form">
                    <a-form-item label="Note">
                      <a-textarea
                        placeholder="Write the note here ... "
                        :rows="4"
                        v-decorator="[
                          'catatan',
                          { rules: [{ required: false }] },
                        ]"
                      />
                    </a-form-item>
                  </a-form>
                  <div style="display: flex; justify-content: end;">
                    <a-button v-if="isRevise" type="primary" icon="save" @click="handleSubmitRevise" :loading="loading.submit">Save</a-button>
                    <a-button v-else type="primary" icon="save" @click="handleSubmit" :loading="loading.submit">Submit</a-button>
                  </div>
                </a-col>
              </a-row>
            </div>
            
          </a-card>
          
        </a-spin>
      </a-card>
    </div>
  </template>
  <script>
  import { mapGetters } from "vuex";
  import axios from "axios";
  import moment from "moment";
  import _, { initial, method } from "lodash";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import HandleRoute from "@/mixins/HandleRoute";
  import GlobalMethod from "@/mixins/GlobalMethod.js";

  const bulan = [
    { bulan: "januari", short: "jan" },
    { bulan: "februari", short: "feb" },
    { bulan: "maret", short: "mar" },
    { bulan: "april", short: "apr" },
    { bulan: "mei", short: "mei" },
    { bulan: "juni", short: "jun" },
    { bulan: "juli", short: "jul" },
    { bulan: "agustus", short: "agu" },
    { bulan: "september", short: "sep" },
    { bulan: "oktober", short: "okt" },
    { bulan: "november", short: "nov" },
    { bulan: "desember", short: "des" }
  ];
  
  export default {
    name: "cooperative-deduction-create",
    mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
    props: ["id"],
    data(){
      let doc_validation = (rule, value, callback) => {
        if (this.fileList.length==0) {
          callback(new Error("Please Complete Your Form Input!"));
        } else {
          callback();
        }
      };
      return {
        doc_validation,
        fileList: [],
        reviseData: {},
        loading: {
          preview: false,
          submit: false,
          page: false,
          reset: false,
          show_data: false
        },
        option: {
          periode : []
        },
        dataSource: {
          data: [],
          dataOriginal: [],
          dataEditOriginal: []
        },
        bulan,
        search: "",
        total_deduction: 0,
        lock_header: false,
        formAction: {
          note: '',
        },
        timeline: [],
        budget_list: [],
        rc_code_list: [],
        year_list: [],
        loading_rc: false,
        budget_selected: '',
        year_selected: '',
        stateRc: {},
        linkDocument: '',
        isRevise: false,
        isDisablePreview: false
      }
    },
    beforeCreate() {
      this.form = this.$form.createForm(this);
    },

    created(){
      this.initialFetch()
    },

    mounted(){
      this.generateOption()
      if(this.id){
        this.isRevise = true
        this.isDisablePreview = true
        this.fetchEditData()
      }
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getDefaultDateFormat",
        "getCostCenter",
        "getPeruntukan",
        "getSubPeruntukan",
        "getAnggaran",
      ]),
      columns() {
        const kolom = [
          {
            title: "No",
            dataIndex: "no",
            key: "no",
            width: 60,
            align: "center",
            fixed: 'left',
            scopedSlots: { customRender: "no" },
          },
          {
            title: "Budgeting",
            dataIndex: "budget",
            key: "budget",
            width: 180,
            align: "center",
            fixed: 'left',
            scopedSlots: { customRender: "budget" }
          },
          {
            title: 'Year ' + this.year_selected,
            children: [
              {
                title: "Code Budget",
                dataIndex: "kode_anggaran",
                key: "kode_anggaran",
                width: 180,
                scopedSlots: { customRender: "kode_anggaran" },
              },
              {
                title: "Unit",
                dataIndex: "unit",
                key: "unit",
                width: 70,
                align: "center",
                scopedSlots: { customRender: "unit" },
              },
              {
                title: "Unit Price",
                dataIndex: "unit_price",
                key: "unit_price",
                width: 150,
                scopedSlots: { customRender: "unit_price" },
              },
              {
                title: "Jan",
                dataIndex: "januari",
                key: "januari",
                width: 150,
                scopedSlots: { customRender: "januari" },
              },
              {
                title: "Feb",
                dataIndex: "februari",
                key: "februari",
                width: 150,
                scopedSlots: { customRender: "februari" },
              },
              {
                title: "Mar",
                dataIndex: "maret",
                key: "maret",
                width: 150,
                scopedSlots: { customRender: "maret" },
              },
              {
                title: "Apr",
                dataIndex: "april",
                key: "april",
                width: 150,
                scopedSlots: { customRender: "april" },
              },
              {
                title: "May",
                dataIndex: "mei",
                key: "mei",
                width: 150,
                scopedSlots: { customRender: "mei" },
              },
              {
                title: "Jun",
                dataIndex: "juni",
                key: "juni",
                width: 150,
                scopedSlots: { customRender: "juni" },
              },
              {
                title: "Jul",
                dataIndex: "juli",
                key: "juli",
                width: 150,
                scopedSlots: { customRender: "juli" },
              },
              {
                title: "Aug",
                dataIndex: "agustus",
                key: "agustus",
                width: 150,
                scopedSlots: { customRender: "agustus" },
              },
              {
                title: "Sep",
                dataIndex: "september",
                key: "september",
                width: 150,
                scopedSlots: { customRender: "september" },
              },
              {
                title: "Okt",
                dataIndex: "oktober",
                key: "oktober",
                width: 150,
                scopedSlots: { customRender: "oktober" },
              },
              {
                title: "Nov",
                dataIndex: "november",
                key: "november",
                width: 150,
                scopedSlots: { customRender: "november" },
              },
              {
                title: "Des",
                dataIndex: "desember",
                key: "desember",
                width: 150,
                scopedSlots: { customRender: "desember" },
              },
              {
                title: "Sub Total",
                dataIndex: "sub_total",
                key: "sub_total",
                width: 150,
                align: "right",
                scopedSlots: { customRender: "sub_total" },
              },
            ]
          }
        ]

        return kolom
      },

    },
    methods:{
      handleRemove() {
        if(!this.lock_header)
          this.fileList = [];
      },
      beforeUpload(file) {
        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 5) {
          this.displayMessage("large-file-5mb");
        } else {
          this.fileList = [];
          this.fileList.push(file);
          this.isDisablePreview = false
          return false;
        }
      },
      onSearch(){
  
      },
      handleDownloadTemplate(){
        this.asyncAxiosGet("potongan_koperasi/template",
          this.getAuth,
          {}
        )
        .then((response) => {
          window.open(this.$serviceUrl + response.url, "_blank");
        })
        .catch((err) => {
          console.log(err);
          this.displayMessage("error-emptyDocTemplate");
        });
      },
      handlePreview(){
        this.form.validateFields((err, values) => {         
          if (err) {
            this.displayMessage("choose-action");
            return;
          }
          
          let data = new FormData();
          data.append("jns_anggaran_id", values.budget_type);
          data.append("year", values.periode);
          data.append("project_id", values.rc_code);
          data.append("file_upload", this.fileList[0]);
  
          this.loading.preview = true
          this.asyncAxiosPost(
            "anggaran/preview",
            "formdata",
            this.getAuth,
            data
          ).then((response) => {
            this.dataSource.data = response.dtl
            this.dataSource.dataOriginal = this.dataSource.data
            this.timeline = response.workflow

            //hitung flex col total peruntukan
            if(response.total_peruntukan.length>3){
              let modulus = response.total_peruntukan.length % 3;
              let rounding = response.total_peruntukan.length - modulus
              this.dataSource['subtotal_row'] = (rounding/3) + modulus
            }else{
              this.dataSource['subtotal_row'] = 1
            }
            this.dataSource['subtotal_data'] = response.total_peruntukan
  
            this.total_deduction = response.total
            this.lock_header = true
            this.loading.preview = false
          })
          .catch(() => {
            this.loading.preview = false
          });
        })
      },
      generateOption(){
        let thn = [moment().format('YYYY'), moment().subtract(1, 'year').format('YYYY')]
        for (let index = 0; index < thn.length; index++) {
          for (let index2 = 0; index2 < 12; index2++) {
            this.option.periode.push({
              value: moment().set('year', thn[index]).set('month', 11-index2).format('YYYY-MM'),
              label: moment().set('year', thn[index]).set('month', 11-index2).format('MMMM YYYY')
            })
          }
        }
        
      },
      generateWorkflow(workflow, params = {}){
        var result = []

        workflow.forEach(function (item) {

          // JIKA ARRAY (multi approver)
          if (Array.isArray(item)) {
            if (!item.length) return

            var stepNo = Number(item[0].step_no)
            var selectedTlc = params[stepNo]
            var selected = null

            if (selectedTlc) {
              selected = item.find(function (i) {
                return i.tlc === selectedTlc
              })
            }

            // fallback ke index pertama
            if (!selected) {
              selected = item[0]
            }

            result.push({
              step_no: Number(selected.step_no),
              tlc: selected.tlc
            })
          }

          // JIKA OBJECT BIASA
          else {
            result.push({
              step_no: Number(item.step_no),
              tlc: item.tlc
            })
          }
        })

        return result
      },
      handleSubmit(){
        const that = this;
        let title = "";
        title = "Are you sure to Submit this data?";
        that.$confirm({
          title: title,
          content: "Yes / No?",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            that.form.validateFields(async (err, values) => {
              if (err) {
                that.displayMessage("choose-action");
                return;
              }

              const new_wf = that.generateWorkflow(that.timeline, values)

              let data = new FormData();

              try {
                data.append("jns_anggaran_id", values.budget_type);
                data.append("year", values.periode);
                data.append("project_id", values.rc_code);
                data.append("note", values.catatan);
                data.append("file_upload", that.fileList[0]);
                data.append("workflow", JSON.stringify(new_wf));
                
                that.loading.submit = true
                const response = await that.asyncAxiosPost(
                  "anggaran",
                  "formdata",
                  that.getAuth,
                  data
                )
                if(response){
                  that.displayMessage("success-save")
                  that.$router.push({ name: "aanggaran.listingAcc" });
                }

              } catch (error) {
                console.log(error);
                that.loading.submit = false
              }
            })
          },
          onCancel() {},
        })
      },

      async handleSubmitRevise(){
        const that = this;
        let title = "";
        title = "Are you sure to Save this data?";
        that.$confirm({
          title: title,
          content: "Yes / No?",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            that.form.validateFields(async (err, values) => {
              if (err) {
                that.displayMessage("choose-action");
                return;
              }
              
              let data = new FormData();

              try {
                data.append("anggaran_id", that.id);
                data.append("file_upload", that.fileList[0]);
                
                that.loading.submit = true
                const response = await that.asyncAxiosPost(
                  "anggaran/edit",
                  "formdata",
                  that.getAuth,
                  data
                )
                if(response){
                  that.displayMessage("success-save")
                  that.$router.push({ name: "aanggaran.listingAcc" });
                }

              } catch (error) {
                console.log(error);
                that.loading.submit = false
              }
            })
          },
          onCancel() {},
        })
      },
      async handleReset(){
        this.loading.reset = true
        this.dataSource.data = []
        this.dataSource.dataOriginal = [] 
        this.dataSource.subtotal_row = null
        this.dataSource.subtotal_data = []
        this.fileList = []
        this.total_deduction = 0
        this.lock_header = false
        this.isDisablePreview = true
        this.loading.reset = false
      },
      fetchEditData(){
        this.loading.page = true
        this.asyncAxiosGet("anggaran",
          this.getAuth,
          { id_manifest: this.id }
        )
        .then(async (response) => {
          this.reviseData = response
          this.dataSource.data = response.dtl
          this.loading.page = false
          
          this.budget_selected = response.budget_type
          this.year_selected = response.year
        })
        .catch((err) => {
          this.loading.page = false
          console.log(err);
        });
      },
      convertfiles(file_name, url, file64) {
        let typefile = file_name.substr(file_name.lastIndexOf("."));
  
        if (typefile == ".xls") {
          typefile = "data:application/vnd.ms-excel;base64,";
        } else if (typefile == ".xlsx") {
          typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
        } else if (typefile == ".doc") {
          typefile = "data:application/msword;base64,";
        } else if (typefile == ".docx") {
          typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
        } else if (typefile == ".pdf") {
          typefile = "data:application/pdf;base64,";
        } else if (typefile == ".jpeg" || typefile == ".jpg") {
          typefile = "data:image/jpeg;base64,";
        } else if (typefile == ".png") {
          typefile = "data:image/png;base64,";
        }
  
        var file = this.dataURLtoFile(
          typefile + file64,
          file_name
        );
        file.uid = "vc-upload-1-1";
        file.status = "done";
        file.exist = true;
        file.url = this.$serviceUrl + url;
        this.fileList = [file];
      },

      initialFetch(){
        this.asyncAxiosGet("anggaran/create",
          this.getAuth,{}
        ).then((response) => {
          this.budget_list = response.budget_type
          this.year_list = response.year
        }).catch((err) => {
          console.log(err);
        })
      },

      setBudget(val){
        this.budget_selected = val
        const dt = this.budget_list.find((d) => d.jns_anggaran_id == val)
        if(dt){
          this.linkDocument = dt.url
        }
        this.clearRc()
      },

      setPeriode(val){
        this.year_selected = val
        this.clearRc()
      },

      clearRc(){
        this.rc_code_list = []
        this.form.setFieldsValue({
          rc_code: ''
        })
        this.stateRc = {}
      },

      handleDownload(){
        window.open(this.$serviceUrl + this.linkDocument, "_blank");
      },

      onChangeRc(val){
        this.loading.show_data = true
        const value = this.rc_code_list.find((e) => {return e.project_id == val || e.cost_center_kode == val})
        
        if(value){
          this.stateRc = value
        }else this.stateRc = {}

        setTimeout(() => {
          this.loading.show_data = false
        }, 250);
      },

      checkBudgetFilters() {
        if (this.budget_selected && this.year_selected) {
          this.loading_rc = true
          this.asyncAxiosGet("anggaran/create",
            this.getAuth,
            {jns_anggaran_id: this.budget_selected, year: this.year_selected}
          ).then((response) => {
            this.rc_code_list = response.data_project
            this.timeline = response.workflow
            this.loading_rc = false
            if(this.isRevise){
              
              let cd_project = this.reviseData.project
              const value = this.rc_code_list.find((e) => {return e.project_id == cd_project || e.cost_center_kode == cd_project})
              if(value)
                this.reviseData.project = value.project_id

              this.onChangeRc(this.reviseData.project)
            }
          }).catch((err) => {
            console.log(err);
            this.loading_rc = false
            
          })
        }
      },

      itemChild(val){
        let c = ''
        if(val.kode_anggaran == null){
          c = 'text-bold';
          if(val.type == 'peruntukan'){
            c = c + ' margin-1'
          } else if(val.type == 'subperuntukan'){
            c = c + ' margin-2'
          }
        }else {
          c = 'margin-item'
        }

        return c;
      }
    },
    watch:{
      "search"(val){
        if(val){ 
          this.dataSource.data = this.dataSource.dataOriginal.filter(item => item.budget.toLowerCase().indexOf(val.toLowerCase()) >=0 )
        }else{
          this.dataSource.data = this.dataSource.dataOriginal
        }
      },

      budget_selected() {
        this.checkBudgetFilters()
      },
      year_selected() {
        this.checkBudgetFilters()
      }
    }
  
  }
  </script>
  <style lang="less" scoped>
  .ccd:deep{
    .ant-table-body{
      thead {
        th {
          text-transform: uppercase;
          text-align: center;
        }
      }
    }
  }
  </style>
  <style lang="less">

    .ant-table-thead {
      background-color: rgba(245, 245, 245, 1);
    }

    .r_same { 
      background-color: fade(@color-secondary, 35%)!important;
    }
  
    .r_not_same { 
      background-color: fade(@color-primary, 35%)!important;
    }

    .side-preview {
      display: flex;
      flex-grow: 1;
      width: 100%;
      height: 100%;
      background-color: white;
      padding: 10px;
      border-radius: 5px;
    }

    .side-preview .title {
      font-weight: bold;
    }

    .list-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
    }

    // .list-item label + span {
    //   text-transform: uppercase;
    // }

    .margin-top-10 {
      margin-top: 14px;
    }

    .action-card {
      width: 100%;
      height: 100%;
      background-color: white;
      padding: 10px;
      border-radius: 5px;
    }

    .text-bold {
      font-weight: bold;
    }

    .margin-1 {
      margin-left: 10px;
    }

    .margin-2 {
      margin-left: 20px;
    }

    .margin-item {
      margin-left: 30px;
    }

    .ant-table-cell {
      white-space: nowrap;
    }

  </style>